<template>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step
          :complete="step > 1"
          step="1"
        ></v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="step > 2"
          step="2"
        ></v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="step > 3"
          step="3"
        ></v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4"></v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step='1' class="pa-0">
          <v-form>
            <v-card>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-container>
                  <v-layout align-center justify-center column >
                    <v-fade-transition leave-absolute>
                      <v-progress-circular
                        v-if="loading"
                        size="24"
                        color="info"
                        indeterminate
                      ></v-progress-circular>
                      <v-avatar
                        v-else
                        color="transparent"
                        size="120">
                        <img :src="require('@/assets/logomarca.png')" alt="trevor">
                      </v-avatar>
                    </v-fade-transition>
                    <v-flex xs12 class="pb-3">
                      <h3 class="display-1 font-weight-light grey--text mb-2">Insira o email</h3>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-text-field
                        v-model="cliente_model.email"
                        outline
                        clearable
                        label="Email do cliente"
                        type="text"
                      >
                      </v-text-field>
                    </v-flex>

                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions color="red" class="info">
                  <v-spacer></v-spacer>
                  <v-btn flat dark @click.prevent="verificarEmail">
                  consultar email
                    <v-icon right>find_replace</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step='2' class="pa-0">
          <v-form ref="form" v-model="validStep1" lazy-validation>
            <v-card>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex
                      xs5
                    >
                      <v-text-field
                        label="Nome"
                        v-model="cliente_model.nome"
                        hint="Insira o primeiro nome"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs7
                    >
                      <v-text-field
                        label="Sobrenome"
                        v-model="cliente_model.sobrenome"
                        hint="Insira o sobrenome"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-select
                        v-model="cliente_model.sexo"
                        :items="itemSexo"
                        item-text="texto"
                        item-value="val"
                        label="Sexo"
                      ></v-select>
                    </v-flex>
                    <v-flex xs9>
                      <v-text-field
                        v-model="cliente_model.email"
                        readonly
                        label="E-mail"
                        required
                      ></v-text-field>

                      <v-alert v-model="alert" type="error" outline>
                        <h4>E-mail já cadastrado!</h4>Insira um novo e-mail.
                      </v-alert>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="cliente_model.telefone"
                        :rules="contato1Rules"
                        mask="(##)#####-####"
                        label="Telefone"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs6
                    >
                      <v-text-field
                        v-model="cliente_model.cpf"
                        :rules="repCpfRules"
                        label="CPF"
                        mask="###.###.###-##"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions class="info">
                  <v-spacer></v-spacer>
                  <v-btn flat dark @click.prevent="salvarUsuario">
                  Salvar cliente
                    <v-icon right>save</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step='3' class="pa-0">
          <v-form ref="form2" v-model="valid" lazy-validation>
            <v-card>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <v-container grid-list-md>
                    <h2 class="mt-4">Endereço do Cliente
                      <v-icon>home</v-icon>
                    </h2>
                    <v-layout row wrap>
                    <v-flex xs4>
                      <v-text-field
                        @keyup="searchCep"
                        v-model="cliente_model.cep"
                        maxlength="8"
                        label="Cep"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs8>
                      <v-text-field
                        v-model="cliente_model.logradouro"
                        label="Logradouro"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3>
                      <v-text-field
                        v-model="cliente_model.numero"
                        label="Nº"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs9>
                      <v-text-field
                        v-model="cliente_model.complemento"
                        label="Complemento"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="cliente_model.bairro"
                        label="Bairro"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-text-field
                        v-model="cliente_model.cidade"
                        label="Cidade"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field
                        v-model="cliente_model.uf"
                        label="UF"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions class="info">
                  <v-btn flat dark @click.prevent="salvarEndereco">
                  Salvar endereco
                    <v-icon right>save</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn flat dark @click.prevent="step++">
                  PULAR
                  </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-stepper-content>
        <v-stepper-content step='4' class="pa-0">
            <v-card>
              <v-card-text
                class="pt-4"
                style="position: relative;"
              >
                <div class="pl-3">
                  <h3 class="display-1 font-weight-light grey--text mb-2">{{finalMessage}}</h3>
                  <div class="font-weight-light title mb-2">
                    Confirme e peça que confirme na sua caixa de email
                  </div>
                </div>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card color="grey lighten-3" class="primary--text pe-3">
                        <v-layout>
                          <v-flex xs3 class="pt-4 pl-4">
                            <v-layout align-center justify-center column >
                              <v-avatar
                                color="grey"
                                size="60">
                                  <img v-if="cliente_model.url_imagem_perfil" :src="cliente_model.url_imagem_perfil" alt="trevor">
                                  <v-icon dark v-else>face</v-icon>
                              </v-avatar>
                            </v-layout>
                          </v-flex>
                          <v-flex xs9>
                            <v-card-title  class="text-xs-right">
                              <div>
                                <div class="headline">{{ cliente_model.nome }}</div>
                                <div>{{ cliente_model.email }}</div>
                                <div>CPF: {{ cliente_model.cpf }}</div>
                              </div>
                            </v-card-title>
                          </v-flex>
                        </v-layout>
                        <v-card-actions class="pa-2 info">
                          <v-spacer></v-spacer>
                          <v-btn flat dark @click.prevent="salvarCliente">
                            Confirmar cadastro
                            <v-icon right>check</v-icon>
                          </v-btn>
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
</template>

<script>
export default {
  data () {
    return {
      finalMessage: '',
      loading: false,
      validStep1: true,
      step: 1,
      alert: false,
      valid: true,
      dialogErro: false,
      menu: false,
      date: null,
      cliente_model: {
        nome: '',
        sobrenome: '',
        cnpj: null,
        cpf: '',
        email: '',
        dataNasc: '',
        sexo: '',
        telefone: '',
        cep: '',
        logradouro: '',
        bairro: '',
        numero: '',
        complemento: '',
        cidade: '',
        estado: '',
        pais: 'Brasil'
      },
      itemSexo: [
        { texto: 'M.', val: 'M' },
        { texto: 'F.', val: 'F' }
      ],
      contato1Rules: [v => !!v || 'Contato obrigatório!'],
      repCpfRules: [v => !!v || 'CPF obrigatório!']
    }
  },
  methods: {
    fechar () {
      this.clear()
      this.step = 1
      this.$emit('fechar')
    },
    searchCep () {
      fetch(`https://viacep.com.br/ws/${this.cliente_model.cep}/json/`, {
        method: 'get',
        mode: 'cors',
        headers: {
          Accept: 'application/json'
        }
      })
        .then(res => res.json())
        .then(json => {
          this.cliente_model.logradouro = json.logradouro
          this.cliente_model.bairro = json.bairro
          this.cliente_model.cidade = json.localidade
          this.cliente_model.estado = json.uf
        })
    },
    sendmailclienteperfil () {
      let mailperfil = {
        message: 'Clique no link para adicinar mais um perfil',
        assunto: 'Bem vindo a Apetrus',
        to: this.cliente_model.email
      }
      this.$store.dispatch('emailCliente', mailperfil)
    },
    sendmailcadcliente () {
      let mailcliente = {
        message: `<!DOCTYPE html><html><head><style>.card {box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);max-width: 600px;margin: auto;text-align: center;font-family: arial;}.price {color: grey;font-size: 22px;}.card a{text-decoration: none;color: #4169E1;}.card button {border: none;outline: 0;padding: 12px;color: white;background-color: #000080;text-align: center;cursor: pointer;width: 100%;font-size: 18px;}.card button:hover {opacity: 0.7;}</style><body><h2 style="text-align:center"><img src="https://www.apetrus.com.br/_img/logop.png" alt=""></h2><div class="card"><img src="https://www.apetrus.com.br/_img/bannercli.png" alt="" style="width:100%"><h1>Parabéns!</h1><p class="price">Falta pouco para você aproveitar todas as nossas <a href="https://www.apetrus.com.br/cliente.html" target="_blank">vantagens</a>.</p><p>Click em "Concluir Cadastro" para gerar sua senha de acesso ao sistema Apetrus.</p><p><a href="https://app.apetrus.com.br/userpasswordconf/?email=${this.cliente_model.email}"><button>Concluir Cadastro</button></a></p></div></body></html>`,
        assunto: 'Bem vindo a Apetrus',
        to: this.cliente_model.email
      }
      this.$store.dispatch('emailCliente', mailcliente)
    },
    salvarUsuario () {
      if (this.$refs.form.validate()) {
        let body = {
          nome: this.cliente_model.nome,
          sobrenome: this.cliente_model.sobrenome,
          email: this.cliente_model.email,
          telefone: this.cliente_model.telefone,
          cpf: this.cliente_model.cpf
        }
        this.$store.dispatch('cadastroPessoa', { cadUser: body }).then((json) => {
          this.cliente_model = { ...this.cliente_model, id_pessoa: json.id_pessoa }
          this.step++
        }).catch((error) => {
          this.$emit('error', error)
          this.fechar()
        })
      }
    },
    salvarCliente () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('inserirCliente', this.cliente_model).then((json) => {
          if (this.cliente_model.id_pessoa) {
            this.sendmailclienteperfil()
          } else {
            this.cliente_model = json.pessoa
            this.sendmailcadcliente()
          }
          this.$emit('info', 'O Cliente foi adicionado ao sistema')
          this.$emit('fechar')
        }).catch((error) => {
          this.$emit('error', error)
          this.fechar()
        })
      }
    },
    salvarEndereco () {
      this.$store.dispatch('atualizarEnderecoPessoa', { cadUser: this.cliente_model }).then(() => {
        this.step++
      })
    },
    clear () {
      this.$refs.form.reset()
    },
    novaFoto () {
      console.log('incluir chamada para a ferramenta de inclusão de foto')
    },
    verificarEmail () {
      this.$store.dispatch('verificarEmail', this.cliente_model.email).then((cliente) => {
        this.cliente_model = cliente
        this.step = 4
        this.finalMessage = `Usuário encontrado`
      }).catch((error) => {
        console.log(error)
        this.step++
      })
    }
  }
}
</script>
